const PROFILE_COLORS = [
  "#FF6B6B", // Red
  "#4ECDC4", // Teal
  "#45B7D1", // Blue
  "#96CEB4", // Green
  "#FFEAA7", // Yellow
  "#DDA0DD", // Plum
  "#98D8C8", // Mint
  "#F7DC6F", // Light Yellow
  "#BB8FCE", // Light Purple
  "#85C1E9", // Light Blue
  "#F8C471", // Orange
  "#82E0AA", // Light Green
  "#F1948A", // Light Red
  "#85929E", // Gray
  "#D7BDE2", // Lavender
  "#A9DFBF", // Pale Green
  "#F9E79F", // Pale Yellow
  "#D5A6BD", // Rose
  "#AED6F1", // Pale Blue
  "#F5B7B1"  // Pink
];

/**
 * Get a random profile color from the predefined color palette
 * @returns {string} Hex color code
 */
export const getRandomProfileColor = () => {
  const randomIndex = Math.floor(Math.random() * PROFILE_COLORS.length);
  return PROFILE_COLORS[randomIndex];
};

/**
 * Get text color (white or black) that contrasts well with the background color
 * @param {string} backgroundColor - Hex color code
 * @returns {string} "#ffffff" or "#000000"
 */
export const getContrastTextColor = (backgroundColor) => {
  // Remove # if present
  const hex = backgroundColor.replace("#", "");
  
  // Convert to RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  // Return black for light colors, white for dark colors
  return luminance > 0.5 ? "#000000" : "#ffffff";
};

/**
 * Generate initials from a name
 * @param {string} name - Player name
 * @returns {string} Initials (max 2 characters)
 */
export const getInitials = (name) => {
  if (!name) return "?";
  
  const words = name.trim().split(" ");
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }
  
  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
};